import { getPathForSpace, getSpaceAttributesFromSpace } from 'account-hybrid/common/components/spaces';
import * as fromSpaces from 'account-hybrid/common/components/spaces/store/reducers/spaces.reducer';
import * as fromStore from 'account-hybrid/store/reducers/index';
import { first, tap } from 'rxjs/operators';
import { LicenseType } from 'account-hybrid/core/authentication/models/licenses';
import { getDefaultSpacetimeState } from 'account-hybrid/features/spacetime/configs/spacetime-view.config';

/**
 * Created by roman.kupin on 6/13/2018.
 */


export class StateConfig {

    static $inject = ["$stateProvider"];

    constructor($stateProvider) {

        $stateProvider
            .state({
                name: 'home',
                url: '/home?redirectTo',
                data: {
                    requiresAuth: true
                },
                template: '',
                resolve: {
                    redirectTo: ['$stateParams', function ($stateParams) {
                        return $stateParams.redirectTo;
                    }]
                },
                controller: ['IdentityService', 'redirectTo', '$location', '$state', 'SpacesService', 'ngrxStore', '$timeout', 'LicenseService',
                    function (identity, redirectTo, $location, $state, SpacesService, ngrxStore, $timeout, licenseService) {

                        if (identity.isAnonymous()) {
                            $state.go('sign-in', { redirectTo: $location.path() });
                        } else if (!!redirectTo) {
                            $location.url(redirectTo);
                        } else if (!SpacesService.current) {

                            ngrxStore.select(fromStore.selectSpaces)
                                .pipe(
                                    first(),
                                    tap((store: fromSpaces.State) => {
                                        if (store.allSpaces.length === 1 && store.collaborativeSpaces.length === 0) {
                                            document.location.href = getPathForSpace(store.allSpaces[0]);
                                        } else {
                                            ngrxStore.dispatch({ type: "[Spaces] Set isCancelVisible", payload: false });
                                            ngrxStore.dispatch({ type: "[Spaces] Set isVisible", payload: true });
                                        }
                                    })
                                )
                                .subscribe()
                        } else {
                            const isFullAccess = identity.isFliptoStaff() || licenseService.getAccountMode() === 'full';
                            if (isFullAccess) {
                                $state.go('hub', getSpaceAttributesFromSpace(SpacesService.current));
                            } else if (licenseService.checkCurrentSpaceLicense(LicenseType.Spacetime)) {
                                // Restricted-mode user: if they have multiple spaces, show selector;
                                // otherwise auto-route into spacetime for their current space.
                                ngrxStore.select(fromStore.selectSpaces)
                                    .pipe(first())
                                    .subscribe((store: fromSpaces.State) => {
                                        const hasMultipleSpaces = store.allSpaces.length > 1 || store.collaborativeSpaces.length > 0;
                                        if (hasMultipleSpaces) {
                                            ngrxStore.dispatch({ type: "[Spaces] Set isCancelVisible", payload: false });
                                            ngrxStore.dispatch({ type: "[Spaces] Set isVisible", payload: true });
                                        } else {
                                            $state.go(getDefaultSpacetimeState(licenseService.getSpacetimeMode()), getSpaceAttributesFromSpace(SpacesService.current));
                                        }
                                    });
                            } else {
                                // Restricted mode without Spacetime license — show spaces selector so user can pick a different space.
                                ngrxStore.dispatch({ type: "[Spaces] Set isCancelVisible", payload: false });
                                ngrxStore.dispatch({ type: "[Spaces] Set isVisible", payload: true });
                            }
                        }
                    }]
            });

    }
}
